import { render } from "./VoucherExchanged.vue?vue&type=template&id=2a9fbd5b&scoped=true"
import script from "./VoucherExchanged.vue?vue&type=script&lang=js"
export * from "./VoucherExchanged.vue?vue&type=script&lang=js"

import "./VoucherExchanged.vue?vue&type=style&index=0&id=2a9fbd5b&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9fbd5b"]])

export default __exports__